import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Row, Col, ButtonGroup, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../store';
import * as StreamItemsStore from '../store/StreamItemsProfile';
import SidebarLeft from './stream-items/SidebarLeft';
import SidebarRight from './stream-items/SidebarRight';
import StreamContent from './stream-items/StreamContent';
// import StreamItemBase from './ItemStreamBase';
import AuthUtil from '../store/AuthUtil';

// At runtime, Redux will merge together...
type StreamItemProps =
    StreamItemsStore.StreamItemsState // ... state we've requested from the Redux store
    & typeof StreamItemsStore.actionCreators // ... plus action creators we've requested
    & RouteComponentProps<{ startIndex: string, userName: string }>; // ... plus incoming routing parameters


class FetchData extends React.PureComponent<StreamItemProps> {
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    // This method is called when the route parameters change
    public componentDidUpdate() {
        this.ensureDataFetched();
    }

    protected ensureDataFetched() {
        const startIndex = parseInt(this.props.match.params.startIndex, 10) || 0;
        const userName = this.props.match.params.userName;
        this.props.requestStreamItems(startIndex, userName);
    }

    public render() {
        return (
            <Row className='tall' key={"1234567890"}>
                <Col md='3'><SidebarLeft></SidebarLeft></Col>
                <Col md='9'>
                    {StreamContent.renderHeader(this.props.items[0], this.props.userName || AuthUtil.getUserName(), true)}
                    {StreamContent.render(this.props.items, this.props.userName, 1)}
                </Col>
                {/* <Col md='4'> { SidebarRight.render(this.props.items, this.props.userName) } </Col> */}
            </Row>
        );
    }
}

export default connect(
    (state: ApplicationState) => state.streamItemsProfile, // Selects which state properties are merged into the component's props
    StreamItemsStore.actionCreators // Selects which action creators are merged into the component's props
)(FetchData as any);

